export enum UrlParameters {
  Vrm = "vrm",
  Mileage = "mileage",
  QualificationId = "qualificationId",
  Jwt = "jwt",
}
